import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    position: "absolute",
    zIndex: 2,
    top: 0,
    right: 0,
    left: 0,
    bottom: 0,
    transition: ".125s ease-out",
    overflowY: "scroll",
    marginRight: "50%",
    "&[aria-expanded=true]": {
      marginRight: "0"
    }
  }
}));

const EditorContent = ({
  className,
  expanded = false,
  children
}) => {
  const classes = useStyles();
  return React.createElement("section", {
    className: className || classes.root,
    "aria-expanded": expanded
  }, children);
};

export default EditorContent;